import { BaseError } from '@kiplin/web-common/error';

export class MissingCommunicationKitConfigurationError extends BaseError {
  constructor() {
    super('8b7b7ee4-7c8c-4df1-9a1b-0b1a2df0d6d5', 'Missing communication kit configuration');
  }
}
